import { AgentCommands, CommandType, UsedCommandType } from '~/constants/commands'
import { useTask } from '~/contexts/TaskContext'
import { useRepoContexts } from '~/hooks/task/useRepoContexts'
import { useTaskAwareMetadata } from '~/hooks/useTaskAware'
import { commandTypeFromJSON } from '~/protos/agents'
import { CodeContextHeader } from './CodeContextHeader'

export function TaskBlockHeader() {
  const { command } = useTaskAwareMetadata()
  const { task } = useTask()
  const commandType = commandTypeFromJSON(command) as CommandType
  const usedCommandType = commandType as UsedCommandType
  const repoContexts = useRepoContexts()

  return (
    <>
      <div className='label flex items-center select-none mx-[10px]'>
        <div className='label-lg-bold pr-1'>Task: </div>
        <div className='label-lg-normal'>
          #{task?.task_id} -{' '}
          {usedCommandType && AgentCommands[usedCommandType]
            ? AgentCommands[usedCommandType].label
            : 'Unknown Task'}
        </div>
      </div>

      <CodeContextHeader repoContexts={repoContexts} commandType={commandType} />
    </>
  )
}
